import { useTranslation } from "@redotech/redo-i18n";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import CircleClose from "@redotech/redo-web/icon-old/x.svg";
import { formatDate } from "@redotech/redo-web/time";
import { memo, useContext, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import * as orderSyncCss from "./index.module.css";

export const OrderSyncProgress = memo(function OrderSyncProgress() {
  const team = useContext(TeamContext);
  const [closed, setClosed] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  let orderSyncComplete = true;
  if (team && team.orderBackfillWatermark) {
    const syncOrdersSync =
      team.orderBackfillMin ||
      Temporal.Now.zonedDateTimeISO("UTC")
        .subtract(Temporal.Duration.from({ days: 60 }))
        .toString();
    orderSyncComplete = team.orderBackfillWatermark <= syncOrdersSync;
  }

  return team &&
    team.orderBackfillWatermark &&
    !orderSyncComplete &&
    false! &&
    !closed ? (
    <div className={orderSyncCss.header}>
      <div>
        {t(
          "Order syncing from Shopify in progress. Orders since {{date}} have been synced.",
          {
            date: formatDate(
              Temporal.Instant.from(team.orderBackfillWatermark),
            ),
          },
        )}
      </div>
      {location.pathname !== "/orders" ? (
        <RouterLink to="/orders">
          <button className={orderSyncCss.retryButton}>
            <span>{t("View orders")}</span>
          </button>
        </RouterLink>
      ) : null}
      <div className={orderSyncCss.closeButton} onClick={() => setClosed(true)}>
        <CircleClose />
      </div>
    </div>
  ) : null;
});
